var module = angular.module('octopusApp.shared');

module.service('variableTypes', function(){

    this.string = function() { return { name: 'String', display: 'Text'}; };
    this.sensitive = function() { return { name: 'Sensitive', display: 'Sensitive'}; };
    this.certificate = function() { return { name: 'Certificate', display: 'Certificate'}; };

    this.all = function() { return [this.string(), this.sensitive(), this.certificate()]; };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/services/variable_types.js
// module id = 4924832857037738
// module chunks = 1